import React from 'react'
import { Form } from 'react-bootstrap'
import { useController } from 'react-hook-form'

// Wrapped UI Component (react-bootstrap) with a react-hook-form controller
// to unclutter forms
const Field = ({ name, control, rules, ...props }) => {
  const { field, fieldState: { invalid, error } } = useController({
    name,
    control,
    rules,
  })

  return (
    <>
      <Form.Control {...field} {...props} isInvalid={invalid}/>
      <Form.Control.Feedback type='invalid'>
        {error?.message}
      </Form.Control.Feedback>
    </>
  )
}

export default Field
